module.exports = __webpack_public_path__ + "img/3.09a713bb.png";